import ChangeStrokeColorAction from "./appearance/ChangeStrokeColorAction";
import ChangeFillColorAction from "./appearance/ChangeFillColorAction";
import AddSpeciesToElementAction from "./elements/AddSpeciesToElementAction";
import MoveAction from "./elements/MoveAction";
import RotateAction from "./elements/RotateAction";
import ChangeCustomLabelAction from "./labels/ChangeCustomLabelAction";
import DeleteCustomLabelAction from "./labels/DeleteCustomLabelAction";
import MoveLabelAction from "./labels/MoveLabelAction";
import NewCustomLabelAction from "./labels/NewCustomLabelAction";
import ToggleFillAction from "./appearance/ToggleFillAction";
import ToggleStrokeAction from "./appearance/ToggleStrokeAction";
import DrawAction from "./elements/DrawAction";
import DeleteAction from "./elements/DeleteAction";
import PlaceAction from "./elements/PlaceAction";
import RemoveSpeciesFromElementAction from "./elements/RemoveSpeciesFromElementAction";
import FieldInputAction from "./elements/FieldInputAction";
import MoveWithArrowKeyAction from "./elements/MoveWithArrowKeyAction";
import BringToFrontAction from "./elements/BringToFrontAction";
import SendToBackAction from "./elements/SendToBackAction";
import BringForwardAction from "./elements/BringForwardAction";
import SendBackwardAction from "./elements/SendBackwardAction";
import RotateImageAction from "./image/RotateImageAction";
import ScaleImageAction from "./image/ScaleImageAction";
import ChangeImageOpacityAction from "./image/ChangeImageOpacityAction";

// Labels
const NEW_CUSTOM_LABEL = 'NEW_CUSTOM_LABEL';
const CHANGE_CUSTOM_LABEL = 'CHANGE_CUSTOM_LABEL';
const DELETE_CUSTOM_LABEL = 'DELETE_CUSTOM_LABEL';
const MOVE_LABEL = 'MOVE_LABEL';

// Elements
const DRAW = 'DRAW';
const DELETE = 'DELETE';
const PLACE = 'PLACE';
const MOVE = 'MOVE';
const ROTATE = 'ROTATE';
const RESHAPE = 'RESHAPE';
const ADD_SPECIES_TO_ELEMENT = 'ADD_SPECIES_TO_ELEMENT';
const REMOVE_SPECIES_FROM_ELEMENT = 'REMOVE_SPECIES_FROM_ELEMENT';
const FIELD_INPUT = 'FIELD_INPUT';
const MOVE_WITH_ARROW_KEY = 'MOVE_WITH_ARROW_KEY';
const BRING_TO_FRONT = 'BRING_TO_FRONT';
const SEND_TO_BACK = 'SEND_TO_BACK';
const BRING_FORWARD = 'BRING_FORWARD';
const SEND_BACKWARD = 'SEND_BACKWARD';

// Appearance
const CHANGE_FILL_COLOR = 'CHANGE_FILL_COLOR';
const CHANGE_STROKE_COLOR = 'CHANGE_STROKE_COLOR';
const TOGGLE_FILL = 'TOGGLE_FILL';
const TOGGLE_STROKE = 'TOGGLE_STROKE';

// Image
const ADD_IMAGE = 'ADD_IMAGE';
const REMOVE_IMAGE = 'REMOVE_IMAGE';
const CHANGE_IMAGE = 'CHANGE_IMAGE';
const MOVE_IMAGE = 'MOVE_IMAGE';
const SCALE_IMAGE = 'SCALE_IMAGE';
const ROTATE_IMAGE = 'ROTATE_IMAGE';
const CHANGE_IMAGE_OPACITY = 'CHANGE_IMAGE_OPACITY';

const ACTION_MAP = {
    // Labels
    NEW_CUSTOM_LABEL: NewCustomLabelAction,
    CHANGE_CUSTOM_LABEL: ChangeCustomLabelAction,
    DELETE_CUSTOM_LABEL: DeleteCustomLabelAction,
    MOVE_LABEL: MoveLabelAction,

    // Elements
    DRAW: DrawAction,
    MOVE: MoveAction,
    ROTATE: RotateAction,
    DELETE: DeleteAction,
    PLACE: PlaceAction,
    ADD_SPECIES_TO_ELEMENT: AddSpeciesToElementAction,
    REMOVE_SPECIES_FROM_ELEMENT: RemoveSpeciesFromElementAction,
    FIELD_INPUT: FieldInputAction,
    MOVE_WITH_ARROW_KEY: MoveWithArrowKeyAction,
    BRING_TO_FRONT: BringToFrontAction,
    SEND_TO_BACK: SendToBackAction,
    BRING_FORWARD: BringForwardAction,
    SEND_BACKWARD: SendBackwardAction,

    // Appearance
    CHANGE_FILL_COLOR: ChangeFillColorAction,
    CHANGE_STROKE_COLOR: ChangeStrokeColorAction,
    TOGGLE_FILL: ToggleFillAction,
    TOGGLE_STROKE: ToggleStrokeAction,

    // Image
    SCALE_IMAGE: ScaleImageAction,
    ROTATE_IMAGE: RotateImageAction,
    CHANGE_IMAGE_OPACITY: ChangeImageOpacityAction,

    /**
     * Custom handling by factory:
     * RESHAPE
     * MOVE_IMAGE
     */
};

export {
    // Labels
    NEW_CUSTOM_LABEL,
    CHANGE_CUSTOM_LABEL,
    DELETE_CUSTOM_LABEL,
    MOVE_LABEL,

    // Elements
    DRAW,
    MOVE,
    ROTATE,
    DELETE,
    PLACE,
    RESHAPE,
    ADD_SPECIES_TO_ELEMENT,
    REMOVE_SPECIES_FROM_ELEMENT,
    FIELD_INPUT,
    MOVE_WITH_ARROW_KEY,
    BRING_TO_FRONT,
    SEND_TO_BACK,
    BRING_FORWARD,
    SEND_BACKWARD,

    // Appearance
    CHANGE_FILL_COLOR,
    CHANGE_STROKE_COLOR,
    TOGGLE_FILL,
    TOGGLE_STROKE,

    // Image
    MOVE_IMAGE,
    SCALE_IMAGE,
    ROTATE_IMAGE,
    CHANGE_IMAGE_OPACITY,

    ACTION_MAP,
};
